import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
  Output,
  EventEmitter
} from '@angular/core';
import {
  NzAutocompleteModule,
  NzOptionSelectionChange
} from 'ng-zorro-antd/auto-complete';
import { IProductV2 } from '@care-portals/api-interfaces';
import { NzInputModule } from 'ng-zorro-antd/input';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ProductFacade } from '../../../+store/product/product.facade';
@Component({
  selector: 'jackhealth-admin-product-selector',
  templateUrl: './product-selector.component.html',
  styleUrls: ['./product-selector.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzInputModule,
    NzAutocompleteModule,
    NzButtonModule
  ]
})
export class ProductSelectorComponent implements OnInit, OnChanges {
  @Input() category: string | number;
  @Output() productSelected: EventEmitter<IProductV2> = new EventEmitter();

  isLoading = false;
  categories = [];
  products: IProductV2[] = [];
  filteredProducts: IProductV2[] = [];
  keyword = '';

  constructor(private facade: ProductFacade) {
    this.facade.loading$.subscribe(res => (this.isLoading = res));
    this.facade.products$.subscribe(res => {
      this.products = res;
      this.filteredProducts = res;
    });
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.category.currentValue !== changes.category.previousValue) {
      this.changeCategory();
    }
  }

  changeCategory() {
    if (this.category === '') {
      return;
    }

    this.facade.loadProducts((this.category || '').toString());
  }

  onChange(e: Event): void {
    const value = (e.target as HTMLInputElement).value;
    this.filteredProducts = this.products.filter(
      product =>
        product.label.toLowerCase().includes(value.toLowerCase()) ||
        (product.subLabel &&
          product.subLabel.toLowerCase().includes(value.toLowerCase()))
    );
  }

  fieldSelected(event: NzOptionSelectionChange, product: IProductV2): void {
    if (event.isUserInput) {
      this.productSelected.emit(product);
      setTimeout(() => {
        this.clearKeyword();
      });
    }
  }

  clearKeyword(): void {
    this.keyword = '';
  }
}
